import { IBase64 } from "@components/general/form/FileInput";
import { FieldType, Model, Schema } from "@core/index";
import { IFeedback, IMember } from ".";

export interface IComment {
    feedback?: IFeedback;
    author?: IMember;
    description?: string;
    created?: number;
    updated?: number;
    attachments?: IBase64[];
}

export class Comment extends Model implements IComment {
    public static schema: Schema = new Schema("Comment");
    public description?: string;
    public created?: number;
    public updated?: number;
    public attachments?: IBase64[];

    constructor(values: IComment) {
        super(Comment.schema);
        this.setValues(values);
    }
}

Comment.schema.addField("created").type(FieldType.Number);
Comment.schema.addField("updated").type(FieldType.Number);
Comment.schema.addField("description").type(FieldType.String).required();
Comment.schema.addField("attachments").type(FieldType.List);
Comment.schema.freeze();